import React from "react";
import PropTypes from "prop-types";

// styled components
import AddressLookUpListStyled from "./AddressLookupList.styled";

const getLink = item => {
    if (item.links) {
        return item.links[0].href;
    }
    return "";
};

const AddressLookupList = ({ addresses, manuallyEnter, handleSelect, handleCancel, message, disableManualEntry }) => (
    <AddressLookUpListStyled>
        {message && (
            <li className="messageBox">
                <div>{message}</div>
                <button className="cancelAddress" onClick={handleCancel} type="button">
                    Cancel
                </button>
            </li>
        )}
        {addresses.map((item, index) => {
            return (
                <li key={item.addressId + index}>
                    <button onClick={handleSelect} data-address={item.displayName} data-address-id={item.addressId} data-link={getLink(item)} type="button" className={item.className}>
                        {item.displayName}
                    </button>
                </li>
            );
        })}
        {// if this option is undefined show option
        !disableManualEntry && (
            <li key="manualEntry">
                <div>Can't find address?</div>
                <button className="green" onClick={manuallyEnter} type="button">
                    Enter address manually...
                </button>
            </li>
        )}
    </AddressLookUpListStyled>
);

export default AddressLookupList;

// props validation
AddressLookupList.propTypes = {
    manuallyEnter: PropTypes.func,
    handleSelect: PropTypes.func,
    handleCancel: PropTypes.func,
    addresses: PropTypes.array,
    message: PropTypes.string,
    disableManualEntry: PropTypes.bool
};
